import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import {apiBaseUrl} from './Config';

class AdminCreateUserModal extends React.Component {
    constructor(props) {
	super(props);

	this.state = {
	    firstname: "",
	    lastname: "",
	    year: "",
	    troop: "",
	    email: "",
	    level: "10",
	    status: "1",
	    active: "1",
	    disabled: true
	};

	this.resource = apiBaseUrl + "adminUsers";

	this.handleChange = this.handleChange.bind(this);
	this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState) {
	// Only do this when one of the fields changes
	if (this.state.firstname !== prevState.firstname ||
	    this.state.lastname !== prevState.lastname ||
	    this.state.email !== prevState.email ||
	    this.state.troop !== prevState.troop ||
	    this.state.year !== prevState.year ||
	    this.state.level !== prevState.level ||
	    this.state.status !== prevState.status ||
	    this.state.active !== prevState.active)
	{
	    // All fields except 'year' have to be filled in to enable submit button
	    if (this.state.firstname !== "" &&
		this.state.lastname !== "" &&
		this.state.email !== "" &&
		this.state.troop !== "" &&
		this.state.level !== "" &&
		this.state.status !== "" &&
		this.state.active !== "")
	    {
		this.setState({disabled: false});
	    } else {
		this.setState({disabled: true});
	    }
	}
    }
    
    handleChange(event) {
	this.setState({[event.target.name]: event.target.value});
    }

    handleSubmit(event) {
	const data = {
	    firstname: this.state.firstname,
	    lastname: this.state.lastname,
	    email: this.state.email,
	    troop: this.state.troop,
	    year: this.state.year,
	    level: this.state.level,
	    status: this.state.status,
	    active: this.state.active
	};

	fetch(this.resource, {
	    method: "POST",
	    headers: {
		"Authorization": "Bearer " + this.props.token,
		"Content-Type": "application/json"
	    },
	    body: JSON.stringify(data)
	})
	    .then((response) => {
		if (response.status === 401) {
		    this.props.onAuthError();
		}
		
		if (!response.ok) {
		    throw new Error("Kunde inte skapa");
		}
		
		return response.json();
	    })
	    .then((result) => {
		this.props.onSuccess();
	    })
	    .catch((error) => {
		this.props.onError();
	    });
	
	event.preventDefault();
    }

    render() {
	return (
	    <Modal show={this.props.show} onHide={this.props.onHide}>
		<Modal.Header closeButton>
		    <Modal.Title>L&auml;gg till anv&auml;ndare</Modal.Title>
		</Modal.Header>
		<Modal.Body>
		    <Form>
			<Form.Group>
			    <Form.Label>F&ouml;rnamn</Form.Label>
			    <Form.Control name="firstname" type="text" autoFocus value={this.state.firstname} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Efternamn</Form.Label>
			    <Form.Control name="lastname" type="text" value={this.state.lastname} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Kurs&aring;r</Form.Label>
			    <Form.Control name="year" type="text" value={this.state.year} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Scouk&aring;r</Form.Label>
			    <Form.Control name="troop" type="text" value={this.state.troop} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Email</Form.Label>
			    <Form.Control name="email" type="text" value={this.state.email} onChange={this.handleChange} />
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Niv&aring;</Form.Label>
			    <Form.Select name="level" type="text" value={this.state.level} onChange={this.handleChange}>
				<option value="1">Admin</option>
				<option value="5">Kursteam</option>
				<option value="10">Alumni</option>
				<option value="99">G&auml;st</option>
			    </Form.Select>
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Status</Form.Label>
			    <Form.Select name="status" value={this.state.status} onChange={this.handleChange}>
				<option value="1">Tillagd</option>
				<option value="2">Beg&auml;rd</option>
				<option value="3">Inbjuden</option>
				<option value="4">Accepterad</option>
				<option value="0">Odefinierad</option>
			    </Form.Select>
			</Form.Group>
			<br />
			<Form.Group>
			    <Form.Label>Aktiv</Form.Label>
			    <Form.Select name="active" value={this.state.active} onChange={this.handleChange}>
				<option value="1">Ja</option>
				<option value="0">Nej</option>
			    </Form.Select>
			</Form.Group>
		    </Form>
		</Modal.Body>
		<Modal.Footer>
		    <Button variant="alumni" onClick={this.props.onHide}>Avbryt</Button>
		    {this.state.disabled?
		     <Button variant="alumni" disabled>Skapa</Button>
		     :
		     <Button variant="alumni" onClick={this.handleSubmit}>Skapa</Button>
		    }
		</Modal.Footer>
	    </Modal>
	);
    }
}

export default AdminCreateUserModal;
